/* eslint-disable */
<template>
    <div id="app" class="raiz">
        <div class="vis-header">
            <h4>Títulos con ISBN registrados en los países de América Latina</h4>
            <p>La producción y edición de libros en portugués y español se ha mantenido constante. Desliza el cursor
                para saber más sobre tu país.</p>
        </div>

        <div class="field is-horizontal vis-controls">
            <div class="field-label is-normal">
                <label class="label">País:</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select id="country-select"
                                    class="is-hovered"
                                    @change="loadCountryData"
                                    v-model="selectedCountry"
                            >
                                <option v-for="country in countries" v-bind:value="country">{{country}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="vis-body">
            <div class="vis-content">
                <vue-plotly :data="vis1.data" :layout="vis1.layout" :options="vis1.options"/>
            </div>
        </div>

        <div class="vis-footer">
            <p>
                <small>Fuente: agencias nacionales del ISBN, con cálculos de
                    <a target="_blank" href="https://cerlalc.org/wp-content/uploads/2019/04/EIL2018_2.pdf">Cerlalc</a>.
                </small>
            </p>
        </div>
    </div>
</template>

<script>
    import d3 from "./d3.import.js";
    import plotly from "./plotly.import";
    import plotES from "plotly.js/lib/locales/es";
    import VuePlotly from "@statnett/vue-plotly";

    plotly.register(plotES);
    plotly.setPlotConfig({locale: "es"});

    export default {
        name: "app",
        components: {
            VuePlotly
        },
        data: () => {
            return {
                vis1: {
                    data: [],
                    layout: {
                        //title: 'Inversión como porcentaje del PIB',
                        showlegend: false,
                        margin: {
                            l: 50,
                            r: 20,
                            b: 30,
                            t: 30,
                            pad: 0
                        },
                        font: {
                            family: "Open Sans, Helvetica, Arial, sans-serif",
                            size: 12,
                            color: "#3C3B3B"
                        },
                        xaxis: {
                            fixedrange: true,
                            tickformat: "%Y",
                        },
                        yaxis: {
                            title: "Títulos con ISBN registrados ",
                            fixedrange: true,
                            range: [0, 2],
                            hoverformat: ".2f"
                        },
                        colorway: ["#34729F"]
                    },
                    options: {}
                },
                matricula_data: undefined,
                countries: [],
                selectedCountry: undefined
            };
        },
        mounted: function () {
            this.loadData();
        },
        methods: {
            loadData: function () {
                let vm = this;
                d3.csv(process.env.BASE_URL + "data/isbns.csv").then(
                    function (data) {
                        vm.matricula_data = data;
                        vm.loadSelectOptions(data);
                    }
                );
            },
            loadSelectOptions: function (data) {
                let vm = this;
                vm.countries.push("Todos los países");
                vm.countries.push(...new Set(data.map(x => x.PAIS_ES)));
                vm.selectedCountry = "Todos los países";
                this.loadCountryData();
            },
            loadCountryData: function () {
                let vm = this;

                let country_data = vm.matricula_data;
                if ("Todos los países" === vm.selectedCountry) {
                    country_data = vm.matricula_data;
                } else {
                    country_data = vm.matricula_data.filter(
                        x => x.PAIS_ES === vm.selectedCountry
                    );
                }
                let maxValue = d3.max(country_data.map(x => +x.ISBN));

                let valuesBySector = d3
                    .nest()
                    .key(function (d) {
                        return d.PAIS_ES;
                    })
                    .entries(country_data)
                    .sort(function (a, b) {
                        return a.year - b.year;
                    });

                vm.vis1.layout.yaxis.range = [0, maxValue * 1.2];

                vm.vis1.data = valuesBySector.map(function (d) {
                    let x = [];
                    let y = [];

                    d.values.forEach(function (d) {
                        x.push(d.ANO);
                        y.push(d.ISBN);
                    });

                    return {
                        type: "scatter",
                        x: x,
                        y: y,
                        name: d.key,
                        line: {
                            shape: "spline",
                            width: 3
                        }
                    };
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "~bulma/bulma";
    @import "assets/typography";

    #app {
        font-family: "Open Sans", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #222;
        max-width: 720px;
        margin: 0 auto;
        padding: 15px 5px;

        border-top: 2px solid #3c3b3b;

        @include mobile {
            padding: 15px 10px;
        }
    }

    div.vis-header {
        h3,
        h4 {
            margin-top: 0;
        }
    }

    div.vis-controls {
        margin-top: 20px;
    }

    div.vis-body {
        min-height: 100px;
        margin-top: 0;
    }

    div.vis-footer {
        margin-top: 10px;
        padding: 5px 0;
        border-top: 1px solid grey;

        p {
            margin-bottom: 0;
        }
    }
</style>
<style lang="scss">
    .modebar {
        display: none !important;
    }
</style>
